import { render, staticRenderFns } from "./SubscriptionPlanCard.vue?vue&type=template&id=29ee81e5&scoped=true&"
import script from "./SubscriptionPlanCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlanCard.vue?vue&type=style&index=0&id=29ee81e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee81e5",
  null
  
)

export default component.exports